import { useNavigate, useSearchParams } from "react-router-dom";
import { DataCardItem } from "types/ui/card-item";
import { IconCalendarClock, IconChevronsDown, IconChevronsUp, IconEqual } from "@tabler/icons-react";
import moment from "moment";
import getUserInitials from "helpers/get-user-initials";
import { useMemo } from "react";
import { TaskStatusEnum } from "types/dict";

interface BoardCardProps {
  card: DataCardItem | undefined;
  columnColor: string;
  getDeadlineColor: (card: DataCardItem) => string;
}

export function BoardCard({ card, columnColor, getDeadlineColor }: BoardCardProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const taskType = searchParams.get("type");

  const isTaskBoard = useMemo(() => {
    return window.location.pathname.includes("tasks") ? true : false;
  }, [window.location.pathname]);

  return (
    <div className="col-12">
      <div
        className="card card-sm cursor-pointer"
        style={{ borderTop: "none" }}
        onClick={() => navigate(`${taskType === "other" ? `/tasks/${card?.id}?type=${taskType}` : card?.id}`)}
      >
        <div className={`card-status-top bg-${columnColor}`}></div>

        {isTaskBoard && card?.status === TaskStatusEnum.REJECTED && <div className="ribbon bg-red">Доработать</div>}

        <div className="card-body">
          <h3 className="card-title">{card?.title}</h3>
          <div className="text-secondary">{card?.description}</div>
          <div className="mt-4">
            <div className="row">
              <div className="col d-flex align-items-center gap-2">
                <span className="avatar avatar-xs rounded" title={card?.assigned_to}>
                  {getUserInitials(card?.assigned_to || "")}
                </span>
                {window.innerWidth < 768 && card?.assigned_to}
              </div>

              {card?.priority && (
                <div className="col-auto d-flex align-items-center">
                  {card?.priority === "Средняя" ? (
                    <IconEqual size={20} className="text-warning" />
                  ) : card?.priority === "Высокая" ? (
                    <IconChevronsUp size={20} className="text-danger" />
                  ) : (
                    <IconChevronsDown size={20} className="text-primary" />
                  )}
                </div>
              )}

              {card?.dueDate && (
                <div className={`col-auto d-flex align-items-center gap-1 ms-1 rounded ${getDeadlineColor(card)}`}>
                  <IconCalendarClock size={20} />
                  <span>{moment(card?.dueDate).format("DD.MM")}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
